import React from 'react'
import '../../../../App.scss';
import Grid from "@material-ui/core/Grid";
import ButtonBackground from '../../../../assets/images/empty_wood_btn.png'
import Clock from '../../../../assets/images/clocks.png'
class Timer extends React.Component{
    constructor(props) {
        super(props)
        this.state = { time: {}, seconds: props.data.seconds };
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }
    secondsToTime(secs){
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    componentDidMount() {
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
        this.startTimer()
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
        }
    }

    render() {
        // const calculateTime=(seconds)=>{
        //     console.log("log")
        //     let hours = Math.floor(seconds / (60 * 60));
        //     let divisor_for_minutes = seconds % (60 * 60);
        //     let minutes = Math.floor(divisor_for_minutes / 60);
        //     let divisor_for_seconds = divisor_for_minutes % 60;
        //     let second = Math.ceil(divisor_for_seconds);
        //     this.setState({
        //         time:`${hours}:${minutes}:${second}`
        //     })
        //     seconds-=1
        // }
        // const {seconds}=this.props.data
        // const {time}=this.state
        // setInterval(() => calculateTime(seconds), 10000)

        return (
            <Grid  container alignItems={"center"}  style={{position:'relative'}} justify={"center"}>
                <p  className='timer-button-text'>
                    تا پایان فصل
                </p>
                <Grid style={{position:'relative',
                    backgroundImage: "url(" + ButtonBackground + ")",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize:'100% 100%',
                }} container justify={"space-around"} className='timer-button'>

                    <Grid sm={9} xs={9} style={{position:'relative'}} container justify={"center"} alignItems={"center"}>
                        <p style={{direction:'ltr'}}>
                            {this.state.time.h} : {this.state.time.m} : {this.state.time.s}

                        </p>
                    </Grid>
                    <Grid sm={2} xs={2} container justify={"center"} alignItems={"center"}>
                        <img src={Clock} style={{width:'100%'}} alt=""/>
                    </Grid>
                </Grid>
            </Grid>

        )
    }
}
export default Timer